<template>
  <div>
    <!-- Modal de Cancelamento da Assinatura Múltipla -->
    <div class="modal" tabindex="-1" role="dialog" id="cancelBatch">
      <div class="modal-dialog" role="document">
        <div class="modal-content" v-if="cancelBatch">
          <div class="modal-header">
            <h5 class="modal-title">
              Cancelando o processo de assinatura para o documento: 
              <strong style="color:black">{{ cancelBatch.row.name }}</strong>.
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>Motivo:</label>
                  <textarea
                    class="form-control"
                    rows="4"
                    v-model="cancelReason"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancelar
            </button>
            <button
              type="button"
              @click="cancel(cancelBatch)"
              class="btn btn-danger"
            >
              Confirmar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Visualização de Documento -->
    <div
      class="modal fade"
      id="modalDocument"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Visualização do Documento
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div>
            <iframe :src="document_http" class="iframe"></iframe>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- -->
    <base-crud
      :ref="table"
      :crudName="crudName"
      :newText="newText"
      :table="table"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="false"
      :enableDelete="false"
      :enableView="false"
      :dataForm="dataForm"
      :detailUrl="detailUrl"
      :extra="extra"
      @view="view"
      @info="info"
      @cancelModal="cancelModal"
    ></base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
export default {
  data() {
    return {
      document_http: "",
      cancelBatch: "",
      cancelReason: "",
      extra: [
        {
          id: 1,
          label: "",
          class: "btn btn-crud yellow",
          title: "Visualizar",
          name: "view",
          icon: "fas fa-eye",
        },
        {
          id: 2,
          label: "",
          class: "btn btn-crud blue",
          title: "Informações",
          name: "info",
          icon: "fas fa-info",
        },
        {
          id: 3,
          label: "",
          class: "btn btn-crud delete",
          title: "Cancelar",
          name: "cancelModal",
          icon: "fas fa-ban",
        },
      ],
      crudName: "Envios avulsos de assinatura múltipla",
      newText: "Cadastrar Assinatura Múltipla",
      table: "multipleSignature",
      columns: [
        "name",
        "requester",
        "nextPerson",
        "sent_date",
        "lastSignedDate",
        "multipleStatus",
        "actions",
      ],
      tableData: [
        "name",
        "requester",
        "nextPerson",
        "sent_date",
        "lastSignedDate",
        "multipleStatus",
      ],
      options: {
        sortIcon: {
          base: "space_fas fas",
          is: "fa-sort",
          up: "fa-sort-amount-up",
          down: "fa-sort-amount-down",
        },
        filterByColumn: true,
        debounce: 1000,
        sortable: ["name", "sent_date"],
        filterable: ["name", "sent_date"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          name: "Nome",
          requester: "Solicitante",
          nextPerson: "Responsável",
          sent_date: "Data de solicitação",
          lastSignedDate: "Data de assinatura",
          multipleStatus: "Status",
          actions: "Ações",
        },
        templates: {
          sent_date(h, row, index) {
            return row.sent_date
              ? moment(row.sent_date).format("DD/MM/YYYY HH:mm:ss")
              : "";
          },
          requester(h, row, index) {
            return row.responsible ? row.responsible.name : "";
          },
          nextPerson(h, row, index) {
            return row.nextPerson ? row.nextPerson.name : "-";
          },
          multipleStatus(h, row, index) {
            return row.multipleStatus ? row.multipleStatus : "-";
          },
          lastSignedDate(h, row, index) {
            return row.lastSignedDate
              ? moment(row.lastSignedDate).format("DD/MM/YYYY HH:mm:ss")
              : "-";
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["responsible"];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "signaturebatches/",
      dataForm: {},
      detailUrl: "multipleSignature/send",
    };
  },
  methods: {
    cancelModal(batch) {
      this.cancelBatch = batch;
      $("#cancelBatch").modal("show");
    },
    cancel(props) {
      if(this.cancelReason == ""){
        this.$message("Erro", "Digite o motivo do cancelamento", "error");
        return
      }
      $("#page_loader").show();
      const self = this;
      const api =
        self.$store.state.api +
        "signature-multiple-user-index/cancel/" + props.row.id;
      const fd = new FormData();
      fd.append("cancel_reason", self.cancelReason);
      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message("Sucesso", "Cancelado com sucesso", "success");
          $('#cancelBatch').modal('toggle');
          self.$refs.multipleSignature.$refs.table.refresh();
          self.cancelReason = "";
          $("#page_loader").hide();
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
          $("#page_loader").hide();
        });
    },
    view(props) {
      this.document_http = props.row.document_http;
      $("#modalDocument").modal();
    },
    info(props) {
      const self = this;
      self.$router.push("signaturebatches/view/" + props.row.id);
    },
    query: function (query) {
      let columns = {
        name: "name",
        sent_date: "sent_date",
      };
      let filters = "&is_detatched_sending=0&orderByDesc=id&is_multiple=1&";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });

      return filters;
    },
  },
  mounted() {},
  components: {
    BaseCrud,
  },
};
</script>
<style scoped>
.iframe {
  width: 100%;
  height: 700px;
}
</style>



// WEBPACK FOOTER //
// src/components/MultipleSignature/Crud.vue